import React from 'react';
import { SelectField } from 'is24-corecss';
import salutation from '../../locale/salutation.json';
import { FieldValues, UseFormRegister } from 'react-hook-form';

type SalutationSelectFieldProps = {
  id: string;
  label: string;
  errorMessage: string | undefined;
  register: UseFormRegister<FieldValues>;
  defaultValue?: string;
};

const SalutationSelectField: React.FC<SalutationSelectFieldProps> = ({
  id,
  label,
  errorMessage,
  register,
  defaultValue = salutation[0].code,
}: SalutationSelectFieldProps) => {
  return (
    <SelectField id={id} label={label} defaultValue={defaultValue} errorMessage={errorMessage} {...register(id)}>
      {salutation.map((item, index) => (
        <option key={index} value={item.code}>
          {item.value}
        </option>
      ))}
    </SelectField>
  );
};

export default SalutationSelectField;
